import DashboardLayout from '@/pages/layout/DashboardLayout.vue';
import RegisterSettingPage from '@/registerInputModule/pages';
import CalendarTable from '@/pages/CalendarTable.vue';
import Notifications from '@/pages/Notifications.vue';
import Inventory from '@/orderControlModule';
import RecommendOrder from '@/recommendOrderModule/pages';
import FirmOrder from '@/orderTableModule/pages';
import NotFound from '@/pages/layout/NotFound.vue';
import InventoryControl from '@/InventoryControlModule/pages/index.vue';
import OrderCalendar from '@/orderCalendarModule/pages/index.vue';
import ForecastForReceipt from '@/customerForecastModule/pages';
import UnmanagedBusinessPage from '@/unmanagedBusinessModule/pages/index.vue';
import SupplierTable from '@/supplierForecastModule/pages';
import NotExportedOrder from '@/notExportedOrderModule/pages';
import UnmatchedOrder from '@/unmatchedOrderModule/pages';
import TrashBin from '@/trashBinModule/pages/index.vue';
import DeletionBusinessPage from '@/deletionBusinessModule/pages';
import SettingsHomePage from '@/settingsModule/pages/SettingsHomePage.vue';
import OrderTemplateListPage from '@/orderTemplateModule/pages/list/OrderTemplateListPage.vue';
import OrderTemplateCreatePage from '@/orderTemplateModule/pages/create/OrderTemplateCreatePage.vue';
import SettingLogicPage from '@/settingsModule/pages/settingContent/SettingLogicPage.vue';
import SettingUnmanagedBusinessPage from '@/settingsModule/pages/settingContent/SettingUnmanagedBusinessPage.vue';
import SettingFormatPage from '@/settingsModule/pages/settingContent/SettingFormatPage.vue';
import SettingBusinessFreeColumnsPage from '@/settingsModule/pages/settingContent/SettingBusinessFreeColumnsPage.vue';
import InventoryTemplatePage from '@/InventoryControlModule/pages/InventoryTemplatePage.vue';
import InventoryDashboard from '@/inventoryDashboardModule/pages/index.vue';
import OverviewListDetailPage from '@/inventoryDashboardModule/pages/OverviewDetail/OverviewListDetailPage.vue';
import OverviewGraphDetailPage from '@/inventoryDashboardModule/pages/OverviewDetail/OverviewGraphDetailPage.vue';
import SettingKpiPage from '@/inventoryDashboardModule/pages/SettingKpiPage.vue';
import OverviewAlertDetailPage from '@/inventoryDashboardModule/pages/OverviewDetail/OverviewAlertDetailPage.vue';
import SettingDashboardAlertPage from '@/inventoryDashboardModule/pages/SettingDashboardAlertPage.vue';
import BulkEditBusinessPage from '@/editBusinessModule/pages/BulkEditBusinessPage.vue';
import EditMasterPage from '@/editBusinessModule/pages/EditMasterPage.vue';

/**
 * 開発環境で使用するrouterを管理する
 * 新たなページを作る際にはここにrouterを追加する
 * 本番環境にも適用させる場合には、deployedRoutersの方にも入れる
 */
const developmentRoutes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/inventory-dashboard',
    children: [
      {
        path: 'input-data',
        meta: { requiresAuth: true },
        component: RegisterSettingPage,
      },
      {
        path: 'business-removal',
        meta: { requiresAuth: true },
        component: DeletionBusinessPage,
      },
      {
        path: 'business-edit',
        meta: { requiresAuth: true },

        children: [
          {
            path: 'bulk',
            meta: { requiresAuth: true },
            component: BulkEditBusinessPage,
          },
          {
            path: 'master',
            meta: { requiresAuth: true },
            component: EditMasterPage,
          },
        ],
      },
      {
        // 取引情報一覧ページ
        path: '/business',
        children: [
          {
            // 管理表
            path: '',
            meta: { requiresAuth: true },
            // component: BusinessTable,
            component: Inventory,
          },
          {
            // 取引情報(発注推奨?)詳細ページ
            path: 'recommend-order',
            children: [
              {
                path: ':id',
                name: 'recommend-order',
                meta: { requiresAuth: true },
                component: RecommendOrder,
              },
              {
                path: 'list/:id',
                name: 'recommend-order-with-list',
                meta: { requiresAuth: true },
                component: RecommendOrder,
              },
            ],
          },
        ],
      },
      {
        // 仕入先内示ページ
        path: 'supplier',
        meta: { requiresAuth: true },
        children: [
          {
            path: '',
            meta: { requiresAuth: true },
            component: SupplierTable,
          },
          {
            path: 'all-businesses',
            name: 'all-businesses',
            meta: { requiresAuth: true },
            component: SupplierTable,
          },
        ],
      },
      {
        // 発注ページ
        path: 'firm-order',
        meta: { requiresAuth: true },
        component: FirmOrder,
      },
      {
        // 未出力の発注ページ
        path: 'not-exported-order',
        name: 'not-exported-order',
        meta: { requiresAuth: true },
        component: NotExportedOrder,
      },
      {
        // 未照合・差異一覧ページ
        path: 'unmatched-orders',
        name: 'unmatched-orders',
        meta: { requiresAuth: true },
        component: UnmatchedOrder,
      },
      {
        path: 'notifications',
        name: 'Notifications',
        meta: { requiresAuth: true },
        component: Notifications,
      },
      {
        path: 'settings',
        meta: { requiresAuth: true },
        children: [
          {
            path: '',
            name: 'settings-home',
            meta: { requiresAuth: true },
            component: SettingsHomePage,
          },
          {
            path: 'logic',
            name: 'setting-logic',
            meta: { requiredAuth: true },
            component: SettingLogicPage,
          },
          {
            path: 'logic/dashboard-alert',
            meta: { requiredAuth: true },
            component: SettingDashboardAlertPage,
          },
          {
            path: 'unmanaged-business',
            name: 'setting-unmanaged-business',
            meta: { requiredAuth: true },
            component: SettingUnmanagedBusinessPage,
          },
          {
            path: 'format',
            name: 'setting-format',
            meta: { requiresAuth: true },
            component: SettingFormatPage,
          },
          {
            path: 'business-free-columns',
            name: 'setting-business-free-columns',
            meta: { requiresAuth: true },
            component: SettingBusinessFreeColumnsPage,
          },
          {
            path: 'templates/order',
            name: 'order-template-list',
            meta: { requiresAuth: true },
            component: OrderTemplateListPage,
          },
          {
            path: 'templates/order/new',
            name: 'order-template-create',
            meta: { requiresAuth: true },
            component: OrderTemplateCreatePage,
          },
          {
            path: 'templates/order/edit',
            name: 'order-template-edit',
            meta: { requiresAuth: true },
            component: OrderTemplateCreatePage,
          },
        ],
      },
      {
        path: '/inventory-control',
        meta: { requiresAuth: true },
        children: [
          {
            path: 'template',
            name: 'inventory-template',
            meta: { requiresAuth: true },
            component: InventoryTemplatePage,
          },
        ],
      },
      {
        // 稼働日カレンダー
        path: 'calendar',
        meta: { requiresAuth: true },
        component: CalendarTable,
      },
      { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },
      {
        path: 'inventory-control',
        component: InventoryControl,
      },
      {
        // 発注カレンダーページ
        path: 'order-calendar',
        meta: { requiresAuth: true },
        component: OrderCalendar,
      },
      {
        path: '/customer',
        meta: { requiresAuth: true },
        children: [
          {
            path: '',
            meta: { requiresAuth: true },
            component: ForecastForReceipt,
          },
          {
            // 取引一覧ページ（forecastForReceiptId指定）
            path: ':forecastForReceiptId',
            name: 'customer-transaction-list',
            meta: { requiresAuth: true },
            component: ForecastForReceipt,
            props: true,
          },
          {
            // ダッシュボードページ
            path: '/customer-forecast-dashboard',
            meta: { requiresAuth: true },
            component: ForecastForReceipt,
          },
          {
            // 内示正答率ページ
            path: '/customer-forecast-accuracy',
            meta: { requiresAuth: true },
            component: ForecastForReceipt,
          },
          {
            // 内示前月差異ページ
            path: '/customer-forecast-difference',
            meta: { requiresAuth: true },
            component: ForecastForReceipt,
          },
          {
            // 内示遍歴ページ
            path: '/customer-forecast-timeline',
            meta: { requiresAuth: true },
            component: ForecastForReceipt,
            props: true,
          },
          {
            // 内示遍歴ページ
            path: '/customer-forecast-timeline/:defaultBusinessId',
            name: 'customer-forecast-timeline',
            meta: { requiresAuth: true },
            component: ForecastForReceipt,
            props: true,
          },
        ],
      },
      {
        path: '/unmanaged-business',
        meta: { requiresAuth: true },
        component: UnmanagedBusinessPage,
      },
      {
        path: 'trash-bin',
        meta: { requiresAuth: true },
        component: TrashBin,
      },
      {
        path: 'inventory-dashboard',
        meta: { requiresAuth: true },
        children: [
          {
            path: '',
            meta: { requiresAuth: true },
            component: InventoryDashboard,
          },
          {
            path: 'stock',
            meta: { requiresAuth: true },
            component: OverviewListDetailPage,
          },
          {
            path: 'forecast-accuracy',
            meta: { requiresAuth: true },
            component: OverviewListDetailPage,
          },
          {
            path: 'kpi-history',
            meta: { requiresAuth: true },
            component: OverviewGraphDetailPage,
          },
          {
            path: 'alerts',
            meta: { requiresAuth: true },
            component: OverviewAlertDetailPage,
          },
          { path: 'setting/kpi', name: 'setting-kpi', meta: { requiresAuth: true }, component: SettingKpiPage },
        ],
      },
    ],
  },
];

/**
 * 本番環境で使用するrouterを管理する
 * 本番環境に追加するrouterがある場合はここに追加する
 */
const productionRoutes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/input-data',
    children: [{ path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound }],
  },
];

// const routes = process.env.NODE_ENV === 'production' ? productionRoutes : developmentRoutes;
const routes = developmentRoutes;

export default routes;
